/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import {
  getGlobalInteractives,
  getSharedInteractives,
  getUserInteractives,
} from '../../../middleware/api';
import {
  setGlobalInteractive,
  setMyinteractive,
  setSharedInteractive,
} from '../../../redux/mediaManagement/images.action';
import './embedTable.scss';
import TableSkeleton from './skeletonLoader';
import { InteractiveItem, items } from './embedUtil';
import { connect, useDispatch, useSelector } from 'react-redux';
import { ParentDataInterface } from '../../../redux/parentDataSlice';
import { removeType, SingleApiCallStateData } from '../../../redux/embedInterctive';
interface EmbedTableProps {
  selectedInteractive: string;
  selectedType: string;
  setSelectedRowData: (val: InteractiveItem[]) => void;
  searchTerm: string | null;
  setMyinteractive: Function;
  refresh: string | null;
  setRefresh: (val: string | null) => void;
  myInterActive: any;
  setGlobalInteractive: Function;
  globalInteractive: any;
  setSharedInteractive: Function;
  sharedInteractive: any;
}

const EmbedTable = ({
  selectedInteractive,
  selectedType,
  setSelectedRowData,
  searchTerm,
  refresh,
  setRefresh,
  setMyinteractive,
  myInterActive,
  setGlobalInteractive,
  globalInteractive,
  setSharedInteractive,
  sharedInteractive,
}: EmbedTableProps) => {
  const [currentActiveTabData, setCurrentActiveTabData] = useState<InteractiveItem[]>([]);
  const [allData, setAllData] = useState<InteractiveItem[]>([]);
  const [searchData, setSearchData] = useState<InteractiveItem[]>([]);
  const [selectedRow, setSelectedRow] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const dataFromParent = useSelector((state: ParentDataInterface) => state.parentData.data);
  const dispatch = useDispatch();
  const singleApiCall = useSelector((state: SingleApiCallStateData) => state.singleApiCall.values);

  useEffect(() => {
    const fetchInteractiveData = async (
      type: 'Private Interactive' | 'Global Interactive' | 'Shared Interactive',
      fetchFn: (id?: string) => Promise<any>,
      data: any[],
      setDataFn: Function,
      id?: string,
    ) => {
      if ((!data || data.length === 0 || refresh === type) && singleApiCall.includes(type)) {
        const result = await fetchFn(id);

        let arrayData;

        if (type === 'Private Interactive') {
          arrayData = result?.userInteractives ?? [];
        } else if (type === 'Global Interactive') {
          arrayData = result?.globalInteractives ?? [];
        } else {
          arrayData = result?.sharedInteractives ?? [];
        }
        arrayData = arrayData.filter((item: any) => item.active === true);
        dispatch(removeType(type));
        setDataFn(arrayData);
        setAllData(arrayData);
        setCurrentActiveTabData(arrayData);
      } else {
        setAllData(data);
        setCurrentActiveTabData(data);
      }
    };

    const fetchData = async () => {
      try {
        setIsLoading(true);
        const { userEmail, userId, orgId, sharedAccountId } = dataFromParent;
        if (selectedInteractive === 'Private Interactive' && userId) {
          await fetchInteractiveData(
            'Private Interactive',
            () => getUserInteractives(userId, orgId),
            myInterActive,
            setMyinteractive,
            userId,
          );
        } else if (selectedInteractive === 'Global Interactive' && orgId) {
          await fetchInteractiveData(
            'Global Interactive',
            () => getGlobalInteractives(userId, orgId),
            globalInteractive,
            setGlobalInteractive,
            orgId,
          );
        } else if (selectedInteractive === 'Shared Interactive' && userEmail) {
          const data = {
            orgid: orgId,
            accountid: sharedAccountId,
            userid: userId,
          };
          await fetchInteractiveData(
            'Shared Interactive',
            () => getSharedInteractives(data),
            sharedInteractive,
            setSharedInteractive,
          );
        }

        setIsLoading(false);
        setRefresh(null);
      } catch (e: any) {
        console.warn(e.message || e);
        setIsLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedInteractive, refresh]);

  useEffect(() => {
    if (!searchTerm || searchTerm.trim() === '') {
      setSelectedRow('');
      setCurrentActiveTabData(searchData);
    } else {
      setSelectedRow('');
      const lowerSearch = searchTerm.toLowerCase();
      const filtered = searchData.filter((item) => item.title?.toLowerCase().includes(lowerSearch));
      setCurrentActiveTabData(filtered);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, currentActiveTabData]);

  useEffect(() => {
    if (selectedType === 'all') {
      setCurrentActiveTabData(allData);
      setSearchData(allData);
    } else {
      const filteredData = allData.filter((item) => {
        return item.library_type?.toLowerCase() === selectedType.toLowerCase();
      });
      setCurrentActiveTabData(filteredData);
      setSearchData(filteredData);
    }
  }, [selectedType, allData]);
  return (
    <>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <div>
          {currentActiveTabData.length > 0 ? (
            <div className='cardWrapper'>
              {currentActiveTabData.map((item, index) => (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                <button
                  key={item.id}
                  className={`cursor-pointer w-100 interActiveDataWrapper ${
                    selectedRow === item.id ? 'active' : ''
                  }`}
                  style={{
                    backgroundColor: index % 2 === 0 ? '#fff' : '#f8f8f8',
                    border: 'none',
                  }}
                  tabIndex={0}
                  onClick={() => {
                    setSelectedRowData([item]);
                    setSelectedRow(item.id as string);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setSelectedRowData([item]);
                      setSelectedRow(item.id as string);
                    }
                  }}
                >
                  <span className='interactiveTitle'>{item.title}</span>
                  <span className='interactiveData'>
                    {' '}
                    {items.find(
                      (option) => option.key.toLowerCase() === item.library_type?.toLowerCase(),
                    )?.label || item.library_type}
                  </span>
                </button>
              ))}
            </div>
          ) : (
            <p className='NointerACtive'> No interactives found</p>
          )}
        </div>
      )}
    </>
  );
};

const mapStateToProps = ({ embed }: any) => ({
  myInterActive: embed.myInterActives ?? [],
  globalInteractive: embed.globalInteractives ?? [],
  sharedInteractive: embed.sharedInteractives ?? [],
});

const mapDispatchToProps = (dispatch: Function) => ({
  setMyinteractive: (data: any) => dispatch(setMyinteractive(data)),
  setGlobalInteractive: (data: any) => dispatch(setGlobalInteractive(data)),
  setSharedInteractive: (data: any) => dispatch(setSharedInteractive(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmbedTable);
